import { FORM_ERROR } from 'final-form';

export default validate => (values) => {
  const result = validate(values);
  if (typeof result === 'string' || result instanceof Error) return { [FORM_ERROR]: result };
  return result;
};
